import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { environment } from '../../../environments/environment';
import { MpsUserService } from '../../services/mps-user.service';
import { MpsFooterComponent } from '../mps-footer/mps-footer.component';
import { MpsHeaderComponent } from '../mps-header/mps-header.component';
import { MpsLoaderComponent } from '../mps-loader/mps-loader.component';
import { MpsNavigationComponent } from '../mps-navigation/mps-navigation.component';

@Component({
  selector: 'mps-app-root',
  templateUrl: './mps-app.component.html',
  styleUrl: './mps-app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MpsLoaderComponent,
    MpsHeaderComponent,
    MpsFooterComponent,
    MpsNavigationComponent,
    TranslatePipe,
    MatSidenavModule,
    RouterOutlet,
  ],
})
export class MpsAppComponent {
  private _matIconRegistry = inject(MatIconRegistry);
  private _domSanitizer = inject(DomSanitizer);
  private _translateService = inject(TranslateService);
  private _userService = inject(MpsUserService);
  private _user = signal(this._userService.getUserSubject().getValue());

  public constructor(private dateAdapter: DateAdapter<any>) {
    this.dateAdapter.setLocale(environment.defaultLocale);
    this.registerSvgIcon();
    this.initTranslationService();
  }

  private initTranslationService() {
    this._translateService.setFallbackLang(environment.defaultLocale);
    this._translateService.addLangs(environment.allowedLanguage);

    if (!this._translateService.getCurrentLang()) {
      const userLang = this._user()?.lang;
      this._translateService.use(
        userLang && this._translateService.getLangs().includes(userLang)
          ? userLang
          : (localStorage.getItem('lang') as string) || environment.defaultLocale
      );
    }
  }

  private registerSvgIcon() {
    const icons = [...environment.mpsIcons, ...environment.appIcons];

    icons.forEach((icon) => {
      this._matIconRegistry.addSvgIcon(
        `total-${icon}`,
        this._domSanitizer.bypassSecurityTrustResourceUrl(`../../../assets/icons/${icon}.svg`)
      );
    });
  }
}
